import * as React from "react";

class DialogHText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="dialogH-text dialogGHI-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 344.176 294.544"
      >
        <g>
          <path
            fill="#FCFAEE"
            d="M58.9,99.4h8.2v2.2h-5.5v3.1h4.7v2.2h-4.7v3.6h5.7v2.2h-8.4V99.4z"
          />
          <path
            fill="#FCFAEE"
            d="M69.3,110c0-2.2,1.7-3.3,5.8-3.7c0-1-0.5-1.7-1.7-1.7c-0.9,0-1.8,0.4-2.8,1l-1-1.7c1.2-0.7,2.6-1.3,4.2-1.3
		c2.6,0,3.9,1.5,3.9,4.4v5.9h-2.2l-0.2-1.1h-0.1c-0.9,0.8-1.9,1.3-3,1.3C70.5,113,69.3,111.7,69.3,110z M75.1,109.9v-2
		c-2.4,0.3-3.3,1-3.3,1.9c0,0.8,0.6,1.1,1.3,1.1C73.9,110.9,74.4,110.5,75.1,109.9z"
          />
          <path
            fill="#FCFAEE"
            d="M79.5,111.6l1.2-1.7c0.9,0.7,1.8,1.1,2.7,1.1c1,0,1.5-0.4,1.5-1.1c0-0.8-1-1.1-2.1-1.5
		c-1.3-0.5-2.8-1.3-2.8-2.9c0-1.8,1.5-3.1,3.7-3.1c1.5,0,2.6,0.6,3.4,1.2l-1.2,1.6c-0.7-0.5-1.4-0.9-2.2-0.9c-0.9,0-1.3,0.4-1.3,1
		c0,0.7,1,1,2.1,1.4c1.3,0.5,2.8,1.2,2.8,3c0,1.8-1.4,3.2-4,3.2C81.9,113,80.5,112.4,79.5,111.6z"
          />
          <path
            fill="#FCFAEE"
            d="M88.7,107.7c0-3.4,2.3-5.3,4.8-5.3s4.8,1.9,4.8,5.3c0,3.3-2.3,5.3-4.8,5.3S88.7,111,88.7,107.7z M95.7,107.7
		c0-1.9-0.8-3.2-2.1-3.2s-2.1,1.2-2.1,3.2c0,1.9,0.8,3.1,2.1,3.1S95.7,109.6,95.7,107.7z"
          />
          <path
            fill="#FCFAEE"
            d="M100.6,102.6h2.2l0.2,1.3h0.1c0.9-0.9,1.9-1.6,3.3-1.6c2.2,0,3.1,1.5,3.1,4.1v6.3h-2.6v-6
		c0-1.5-0.4-2.1-1.4-2.1c-0.8,0-1.4,0.4-2.1,1.1v6.9h-2.6V102.6z"
          />
          <path
            fill="#FCFAEE"
            d="M123.1,108.6c-0.2,0.9-0.6,1.8-1.1,2.6c1.8,0.6,3.9,0.9,6.4,1c-0.5,0.5-1,1.4-1.3,2c-2.6-0.2-4.8-0.7-6.6-1.5
		c-0.9,0.6-2.1,1.2-3.5,1.7c-0.3-0.5-0.9-1.3-1.3-1.8c1.2-0.3,2.2-0.6,2.9-1c-0.8-0.6-1.5-1.3-2.1-2.1l1.9-0.6
		c0.5,0.6,1.1,1.1,1.8,1.5c0.5-0.5,0.7-1.1,0.9-1.7H117v-7.2h4.1v-1.1h-4.4v-1.6c-0.4,1.1-0.9,2.3-1.5,3.3v12.2h-2.1v-8.9
		c-0.3,0.4-0.6,0.8-0.9,1.2c-0.2-0.5-0.8-1.7-1.2-2.2c1.5-1.6,3-4.2,3.8-6.8l2,0.6l-0.1,0.2h10.9v1.9h-4.5v1.1h4.1v7.2H123.1z
		 M119,104.2h2.2v-1.3H119V104.2z M121.2,107c0-0.2,0-0.5,0-0.7v-0.6H119v1.3H121.2z M125.3,105.7h-2v0.6c0,0.2,0,0.5,0,0.7h2V105.7
		z M123.3,102.9v1.3h2v-1.3H123.3z"
          />
          <path
            fill="#FCFAEE"
            d="M139.7,106.5c-0.7,0.3-1.4,0.6-2.1,1h6.7v6.8h-2.2v-0.5h-6.9v0.5h-2.1V109c-1,0.3-2,0.5-3,0.8
		c-0.2-0.4-0.6-1.3-0.9-1.7c2-0.4,4.1-0.9,6-1.6h-5.5v-1.8h5.8v-1h-4.3v-1.7h4.3v-1h2.1v1h4v1.5c0.9-0.6,1.7-1.2,2.4-2l1.6,1
		c-0.8,0.8-1.7,1.5-2.7,2.2h2.9v1.8H139.7z M133,100.3h-3.3v-1.8h3.3v-1h2.1v1h2.3v1.8h-2.3v1.1H133V100.3z M142.1,109.1h-6.9v0.9
		h6.9V109.1z M142.1,112.2v-0.9h-6.9v0.9H142.1z M137.6,104.7h1.9c0.6-0.3,1.2-0.7,1.7-1h-3.6V104.7z M140.5,100.3H138v-1.8h2.4v-1
		h2.1v1h3.1v1.8h-3.1v1.1h-2.1V100.3z"
          />
          <path
            fill="#FCFAEE"
            d="M147.3,112.7c0.7-1,1.3-2.3,1.7-3.5l1.9,0.8c-0.5,1.1-1,2.6-1.6,3.6L147.3,112.7z M150,102.6
		c-0.4,0.3-0.7,0.5-1.1,0.7c-0.3-0.5-1-1.3-1.5-1.6c2.3-1.2,3.9-2.9,4.8-4.4l2.3,0.5c-0.2,0.3-0.4,0.6-0.6,0.9h3.9l0.3-0.1l1.5,0.9
		c-0.4,0.6-0.9,1.4-1.4,2.1h3.8v2.6h1.8v1.6H162v2.6h-5.9c0.7,0.6,1.5,1.4,2,2l-1.6,1.2c-0.4-0.7-1.5-1.8-2.4-2.5l1-0.7h-5.3v-1.7
		h10.1v-0.9h-11.8v-1.6h11.8v-0.9H150V102.6z M152.5,100.5c-0.4,0.4-0.8,0.8-1.3,1.2h4.4c0.3-0.4,0.6-0.8,0.9-1.2H152.5z
		 M157.7,112.1c0.8,0,1-0.2,1.1-1.7c0.5,0.3,1.4,0.6,2,0.7c-0.3,2.3-0.9,2.8-2.8,2.8h-3.5c-2.6,0-3.2-0.6-3.2-2.4v-2.2h2.2v2.2
		c0,0.5,0.2,0.6,1.2,0.6H157.7z M162.2,108.9c0.8,1.2,1.6,2.8,1.9,3.9l-2,0.8c-0.3-1-1-2.7-1.8-4L162.2,108.9z"
          />
          <path
            fill="#FCFAEE"
            d="M171,106.9l0.5,1.9c-1.9,0.9-3.9,1.9-5.5,2.6l-0.9-2.2c0.7-0.2,1.5-0.5,2.3-0.9v-4.8h-1.9v-2h1.9v-3.9h2v3.9
		h1.7v2h-1.7v3.9L171,106.9z M179.1,112c1,0,1.2-0.4,1.3-2.3c0.5,0.3,1.3,0.7,1.9,0.8c-0.3,2.5-0.9,3.4-3,3.4h-3.8
		c-2.4,0-3.1-0.7-3.1-3.1v-4.6l-1,0.4l-0.8-1.9l1.8-0.8v-4.7h2.1v3.9l1.5-0.6v-5h2v4.1l2-0.8l1.6,0.5l-0.1,0.3
		c-0.1,2.5-0.4,5.8-0.8,7.9l-1.7-0.5c0.2-1.5,0.3-3.7,0.4-5.9l-1.4,0.6v6.4h-2v-5.5l-1.5,0.6v5.6c0,1,0.2,1.2,1.3,1.2H179.1z"
          />
          <path
            fill="#FCFAEE"
            d="M186.3,104.9v9.4h-2.1V98.2h6.9v6.7H186.3z M186.3,99.8v1h2.8v-1H186.3z M189.1,103.2v-1h-2.8v1H189.1z
		 M190.2,111.8v1h-2v-6.7h7v5.7H190.2z M190.2,107.9v2.1h3v-2.1H190.2z M199.4,111.7c0,1.2-0.3,1.8-1,2.1c-0.7,0.4-1.9,0.4-3.5,0.4
		c-0.1-0.6-0.4-1.6-0.7-2.2c1,0.1,2.3,0.1,2.6,0c0.3,0,0.5-0.1,0.5-0.4v-6.8h-4.9v-6.7h7.1V111.7z M194.3,99.8v1h2.8v-1H194.3z
		 M197.2,103.3v-1h-2.8v1H197.2z"
          />
          <path
            fill="#FCFAEE"
            d="M203.5,101.8c0-1,0.8-1.7,1.7-1.7s1.7,0.7,1.7,1.7c0,1-0.8,1.7-1.7,1.7S203.5,102.7,203.5,101.8z
		 M203.5,110.3c0-1,0.8-1.7,1.7-1.7s1.7,0.7,1.7,1.7c0,1-0.8,1.7-1.7,1.7S203.5,111.3,203.5,110.3z"
          />
          <path fill="#FCFAEE" d="M60.1,125h6v1.9h-3.8v9.6h-2.1V125z" />
          <path
            fill="#FCFAEE"
            d="M75.4,126c0,0,0,0.8,0,1.1c0,9.3,0,12.5-0.6,13.4c-0.4,0.7-0.8,0.9-1.4,1c-0.6,0.1-1.3,0.1-2.2,0.1
		c0-0.7-0.3-1.6-0.6-2.3c0.7,0.1,1.3,0.1,1.6,0.1c0.2,0,0.4-0.1,0.6-0.4c0.2-0.3,0.3-1.2,0.3-3.1H71c-0.5,2.4-1.2,4.4-2.5,5.9
		c-0.3-0.4-1.3-1.2-1.7-1.6c1-1.1,1.7-2.6,2.1-4.3h-1.7v-1.9h2c0.1-0.7,0.1-1.4,0.2-2.1h-2v-1.9h2.1c0-0.7,0-1.4,0-2.2h-2.3V126
		H75.4z M73.2,134.1c0-0.6,0-1.3,0-2.1h-1.8c-0.1,0.7-0.1,1.4-0.2,2.1H73.2z M71.6,127.9c0,0.7,0,1.5-0.1,2.2h1.7l0-2.2H71.6z
		 M83.7,126.8c-0.7,1.7-1.5,3.7-2.3,5.3c1.7,1.6,2,3,2,4.2c0,1.3-0.3,2.1-1.1,2.6c-0.4,0.2-0.8,0.4-1.3,0.4c-0.5,0.1-1.1,0.1-1.7,0
		c0-0.6-0.3-1.4-0.6-2c0.5,0.1,1,0.1,1.3,0c0.3,0,0.6-0.1,0.8-0.2c0.4-0.2,0.5-0.6,0.5-1.2c0-1-0.5-2.3-2.1-3.7
		c0.6-1.3,1.2-3.1,1.7-4.4h-2.4v13.9h-2v-16h5.3l0.3-0.1L83.7,126.8z"
          />
          <path
            fill="#FCFAEE"
            d="M100.8,133.6c-0.8,1.5-1.8,2.8-3,3.9c0.5,1.4,1,2.2,1.6,2.2c0.4,0,0.6-0.9,0.7-3c0.5,0.5,1.2,1,1.8,1.2
		c-0.3,3.2-1,3.9-2.6,3.9c-1.3,0-2.3-1.1-3.1-2.8c-1,0.9-2.2,1.6-3.3,2.2c-0.3-0.5-0.9-1.2-1.4-1.7c1.4-0.6,2.8-1.5,4-2.5
		c-0.4-1.4-0.7-3.1-0.9-4.8h-3.7v2.1c0.9-0.2,1.9-0.3,2.8-0.5l0.2,1.9l-2.9,0.6v3.1c0,1.2-0.3,1.7-1,2.1c-0.7,0.3-1.8,0.4-3.2,0.4
		c-0.1-0.6-0.5-1.6-0.8-2.2c1,0.1,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-2.6c-1.2,0.2-2.3,0.5-3.2,0.6l-0.5-2.2c1-0.2,2.3-0.4,3.7-0.6
		v-2.4h-3.4v-2h3.4v-2.1c-1,0.2-2,0.3-2.9,0.4c-0.1-0.5-0.4-1.3-0.6-1.8c2.5-0.3,5.3-0.9,7.1-1.5l1.4,1.8c-0.9,0.3-1.9,0.5-2.9,0.7
		v2.4h3.5c-0.1-1.6-0.2-3.3-0.2-4.9h2.3c0,1.7,0,3.3,0.2,4.9h4.9v2h-4.7c0.1,1.1,0.3,2.1,0.5,3c0.6-0.8,1.2-1.6,1.7-2.4L100.8,133.6
		z M99.5,129.6c-0.5-0.8-1.6-2.1-2.6-3l1.6-1.1c1,0.8,2.1,2,2.7,2.9L99.5,129.6z"
          />
          <path
            fill="#FCFAEE"
            d="M110.6,132.6c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2-0.2-0.6-0.6-0.9-0.8v4.6h-1.8v-4.2c-0.3,0.3-0.6,0.5-0.8,0.8
		c-0.1-0.2-0.4-0.5-0.7-0.8c-0.1,2.9-0.4,6.9-1.7,9.4c-0.3-0.4-1.2-1-1.6-1.2c1.3-2.6,1.4-6.4,1.4-9.1v-5.3h6.9
		c-0.2-0.4-0.4-0.7-0.6-1l1.9-0.5c0.3,0.4,0.7,1,0.9,1.5h6.2v1.7h-3.7c0.3,0.4,0.6,0.9,0.8,1.2l-0.5,0.2h3v1.2h-2.7v0.6h2.3v1h-2.3
		v0.7h2.3v1h-2.3v0.7h2.9v1.3h-6.5c1,0.5,2.1,1.1,2.7,1.7l-1.3,1.2c-0.6-0.6-1.8-1.4-2.8-1.9l0.5-0.5h-1.2V132.6z M105.5,140.6
		c0.9-0.7,1.5-1.9,1.8-3.1l1.7,0.6c-0.4,1.3-0.9,2.6-1.9,3.5L105.5,140.6z M106.1,131.4c1-0.9,1.9-2.1,2.5-3.3h-2.5V131.4z
		 M110.4,128.5c-0.3,0.6-0.6,1.2-1,1.7v1.1c0.9-0.9,1.6-2.1,2.1-3.2h-2.4L110.4,128.5z M114.2,140.1c0.5,0,0.6-0.2,0.6-1.3
		c0.4,0.3,1.2,0.6,1.7,0.7c-0.2,1.8-0.7,2.3-2.1,2.3h-2.3c-1.9,0-2.4-0.5-2.4-2.1v-2h1.9v1.9c0,0.5,0.1,0.5,0.7,0.5H114.2z
		 M114.7,129.5c-0.2-0.4-0.4-0.7-0.7-1.1l1-0.4h-2.8l1,0.3c-0.2,0.4-0.4,0.8-0.6,1.2H114.7z M114.5,130.8h-2.1v0.6h2.1V130.8z
		 M114.5,132.4h-2.1v0.7h2.1V132.4z M114.5,134.1h-2.1v0.7h2.1V134.1z M117.3,137.3c0.9,1,2,2.4,2.4,3.4l-1.7,0.8
		c-0.3-1-1.3-2.4-2.2-3.5L117.3,137.3z"
          />
          <path
            fill="#FCFAEE"
            d="M127.9,129.7H121V128h3c-0.3-0.7-0.7-1.6-1.1-2.3l1.6-0.8c0.5,0.7,1,1.7,1.3,2.4l-1.2,0.6h3.3V129.7z
		 M121.7,132.2v-1.6h5.4v1.6H121.7z M127.2,134.6h-5.4V133h5.4V134.6z M137.4,134.3c-0.7,1.3-1.6,2.4-2.6,3.5c1.1,0.9,2.3,2,2.9,2.8
		l-1.7,1.3c-0.6-0.8-1.7-1.9-2.7-2.8c-1.5,1.2-3.3,2.2-5.3,2.9c-0.2-0.3-0.5-0.8-0.8-1.2v0.2h-3.6v0.8h-1.8v-6.2h5.4v4.7
		c3.9-1.3,6.9-3.8,8.2-6.6L137.4,134.3z M125.4,137.2h-1.9v2h1.9V137.2z M136.3,130.8c-1.5,2.9-4.2,5.5-7.4,7.1
		c-0.3-0.4-0.8-1.1-1.1-1.5c1.5-0.7,2.9-1.7,4.1-2.8c-2.3,0.2-2.8,0.3-3.2,0.4c-0.1-0.5-0.3-1.4-0.4-1.9c0.4-0.1,1-0.2,1.3-0.6
		c0.3-0.3,0.9-1.5,1.4-2.4h-2.7v-1.9h3.9c-0.2-0.6-0.4-1.2-0.6-1.7l1.9-0.6c0.4,0.7,0.7,1.6,0.9,2.3h3.3v1.9H133
		c-0.5,0.9-1,1.9-1.5,2.8l1.9-0.1c0.4-0.5,0.7-1.1,1-1.6L136.3,130.8z"
          />
          <path
            fill="#FCFAEE"
            d="M139.1,140.3c0.6-1.2,1.2-2.9,1.6-4.2l1.9,0.8c-0.4,1.4-0.9,3.2-1.5,4.4L139.1,140.3z M143.7,128.7
		c-0.8,1.5-1.8,2.8-2.8,3.8c-0.4-0.4-1.2-1.2-1.8-1.5c1.7-1.4,3-3.6,3.7-6l2.2,0.5c-0.1,0.4-0.3,0.9-0.5,1.3h10.5v1.8h-7.7v1h6.7
		v1.7h-6.7v1.1h7.1v1.7h-7.1v0.8c0.9,0.7,2.1,1.6,2.7,2.1l-1.4,1.5c-0.6-0.7-2-1.8-2.9-2.5l0.6-0.6h-1.2v-6.9H143.7z M153.6,141.2
		c-0.2-0.6-0.5-1.5-0.9-2.4c-0.3,2.2-0.9,2.8-2.9,2.8h-3.6c-2.6,0-3.2-0.6-3.2-2.5v-2.8h2.1v2.8c0,0.5,0.2,0.6,1.3,0.6h3.2
		c0.9,0,1-0.2,1.1-1.7c0.5,0.3,1.3,0.6,1.9,0.8c-0.3-0.8-0.7-1.6-1-2.4l2-0.6c0.7,1.5,1.7,3.4,2.1,4.6L153.6,141.2z"
          />
          <path
            fill="#FCFAEE"
            d="M160.2,128.3v3.1c0,2.9-0.3,7.6-1.6,10.5c-0.4-0.4-1.3-1.1-1.7-1.3c1.2-2.7,1.3-6.5,1.3-9.2v-5h6.8
		c-0.1-0.4-0.2-0.8-0.3-1.1l2.2-0.4c0.2,0.5,0.4,1,0.5,1.5h6.1v1.9H160.2z M162.2,132.4c0,0.9-0.1,2-0.9,2.8c-0.2-0.3-0.7-0.7-1-0.8
		c0.7-0.5,0.8-1.4,0.8-2v-0.7h1.2V132.4z M170.4,137.3c0.9,1.1,2.2,2.6,2.9,3.5l-1.6,0.9c-0.2-0.3-0.4-0.6-0.7-0.9
		c-8.5,0.6-9.5,0.6-10.1,0.8c-0.1-0.3-0.3-1.2-0.5-1.7c0.6-0.1,1.2-0.3,2.1-0.8c0.4-0.2,1.2-0.5,2-1c-2.3,0.1-2.7,0.2-3,0.3
		c-0.1-0.3-0.3-1.1-0.5-1.6c0.3,0,0.7-0.2,1.2-0.5c0.5-0.2,1.9-1,3-2c-0.4-0.2-0.5-0.5-0.5-1.2v-1.5h1.1v1.5c0,0.3,0,0.4,0.2,0.4
		c0.1,0,0.4,0,0.6-0.1c0,0.2,0,0.4,0,0.6c0.6-0.5,0.7-1.3,0.7-1.8v-0.7h1.2v0.7c0,0.9-0.1,1.9-1,2.6c-0.2-0.3-0.6-0.6-0.9-0.8l0,0.2
		c-0.1,0.1-0.4,0.1-0.6,0.1h-0.3h0l1.1,0.7c-0.9,0.6-1.9,1.3-2.8,1.8l2.7-0.1c0.8-0.5,1.7-1.1,2.4-1.7l1.6,1.1
		c-1.9,1.4-3.9,2.5-5.8,3.4l5.1-0.3c-0.4-0.4-0.7-0.8-1-1.2L170.4,137.3z M162.7,134.8v-3.8h-2v-1.6h2v-0.8h1.6v0.8h2.2v1.6h-2.2
		v3.8H162.7z M169.1,134.9v-3.8h-2.2v-1.6h2.2v-0.8h1.6v0.8h2.6v1.6h-2.6v3.8H169.1z M172.9,133.8c0.2,0,0.5,0,0.7-0.1
		c0,0.3,0,0.6,0.1,0.9c-0.2,0.1-0.5,0.1-0.7,0.1h-0.6c-0.9,0-1.1-0.4-1.1-1.3v-1.8h1.2v1.8c0,0.3,0,0.4,0.2,0.4H172.9z"
          />
          <path
            fill="#FCFAEE"
            d="M180.1,125.7c-0.4,1.2-0.9,2.4-1.4,3.6v12.5h-2v-9c-0.4,0.5-0.7,1-1.1,1.5c-0.2-0.5-0.7-1.8-1-2.3
		c1.5-1.7,2.8-4.3,3.6-6.9L180.1,125.7z M190.9,130.2c-0.3,2.8-0.7,5.2-1.6,7.1c0.6,1.2,1.5,2.1,2.6,2.8c-0.4,0.4-1,1.2-1.3,1.7
		c-1-0.7-1.7-1.6-2.3-2.6c-0.7,1-1.6,1.9-2.7,2.6c-0.2-0.4-0.9-1.1-1.3-1.4c0.2-0.1,0.5-0.3,0.7-0.5h-3.4v1.3h-1.8v-8h1.8v-2.9h-2.1
		v-1.9h2.1v-3h2v3h1.9v1.9h-1.9v2.9h1.4c-0.2-0.2-0.3-0.5-0.4-0.6c1.2-1.8,1.9-4.6,2.3-7.5l1.9,0.3c-0.2,1-0.3,2-0.6,3h3.7v1.8
		H190.9z M183.3,135h-1.9v3.1h1.9V135z M185.2,139.7c0.8-0.7,1.5-1.5,2.1-2.4c-0.5-1.2-0.8-2.5-1.1-3.8c-0.2,0.4-0.4,0.7-0.6,1
		c-0.1-0.2-0.2-0.4-0.4-0.6V139.7z M187.5,130.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,1.4,0.4,2.8,0.8,4.2c0.4-1.4,0.7-3,0.8-4.7H187.5z"
          />
          <path
            fill="#FCFAEE"
            d="M209.2,130.8h-4.1v8.2c0,1.4-0.3,1.9-1.1,2.3c-0.8,0.4-2,0.4-3.8,0.4c-0.1-0.6-0.4-1.7-0.7-2.3
		c1.1,0.1,2.4,0.1,2.8,0.1c0.4,0,0.5-0.1,0.5-0.5v-7.5c-2,3.3-5.1,6.6-8.2,8.5c-0.4-0.6-1.1-1.4-1.7-1.9c3-1.5,5.8-4.3,7.7-7.2h-7.1
		v-2.2h9.3v-3.5h2.4v3.5h4.1V130.8z"
          />
          <path
            fill="#FCFAEE"
            d="M217.7,130.6c-0.1,1.9-0.3,4.1-1.2,6.2c0.9,0.8,1.7,1.5,2.2,2.2l-1.4,1.8c-0.5-0.6-1.1-1.3-1.8-2
		c-0.8,1.1-1.7,2.2-3.1,3.2c-0.3-0.5-1-1.2-1.5-1.5c1.3-1,2.3-2,3-3.2c-0.9-0.8-1.9-1.7-2.7-2.4c0.3-1.1,0.6-2.4,0.8-3.9l-1,0.1
		l-0.2-2c0.5,0,1,0,1.5-0.1c0.2-1.3,0.3-2.6,0.4-3.8l2.1,0.1c-0.1,1.1-0.3,2.4-0.5,3.6l1.3-0.1v-1.1h2v1l0.9-0.1v1.9L217.7,130.6z
		 M214.1,130.8c-0.2,1.2-0.4,2.4-0.7,3.4c0.5,0.4,0.9,0.8,1.4,1.2c0.6-1.6,0.8-3.3,0.9-4.7L214.1,130.8z M227.7,134.5h-3.6v5.1
		c0,1.1-0.2,1.6-1,2c-0.7,0.3-1.7,0.4-3.2,0.3c-0.1-0.6-0.4-1.5-0.7-2c0.9,0,1.9,0,2.2,0c0.3,0,0.4-0.1,0.4-0.3v-5h-3.8v-2h3.8v-1.7
		c0.8-0.7,1.6-1.7,2.2-2.6h-5.3v-1.9h6.7l0.5-0.1l1.4,1c-0.8,1.3-2,2.8-3.3,4v1.4h3.6V134.5z"
          />
          <path
            fill="#FCFAEE"
            d="M231.3,137.4v1.4h-1.9v-12.2h5.3v10.7H231.3z M231.3,128.7v6.6h1.5v-6.6H231.3z M237.9,131.4v0.7
		c0,3-0.3,7.1-2.5,9.7c-0.4-0.3-1.2-0.9-1.7-1.1c2-2.4,2.2-5.9,2.2-8.5v-6.2h9.2v5.5H237.9z M237.9,127.8v1.6h5.2v-1.6H237.9z
		 M243.3,139.6c0.6,0,0.7-0.3,0.7-2.3c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.6-0.8,3.3-2.4,3.3h-2.3c-1.9,0-2.4-0.6-2.4-2.6V132h2v2.1h4.8
		v1.7h-4.8v3c0,0.7,0.1,0.8,0.7,0.8H243.3z"
          />
          <path
            fill="#FCFAEE"
            d="M254.5,130.5c0-1.1-0.9-1.7-2.3-1.7c-1.1,0-2.1,0.5-2.9,1.4l-1.5-1.4c1.1-1.3,2.7-2.2,4.6-2.2
		c2.6,0,4.5,1.2,4.5,3.6c0,2.6-3.9,3-3.7,5.5h-2.3C250.7,132.9,254.5,132.2,254.5,130.5z M252.3,136.9c1.1,0,1.9,0.7,1.9,1.8
		c0,1-0.8,1.8-1.9,1.8s-1.9-0.7-1.9-1.8C250.4,137.7,251.2,136.9,252.3,136.9z"
          />
          <path fill="#FCFAEE" d="M265,142h-6V140h3.8v-9.6h2.1V142z" />
        </g>
      </svg>
    );
  }
}

export default DialogHText;



// WEBPACK FOOTER //
// ./src/storyA/components/DialogHText.tsx